import { IDeleteMotivoDemissaoUseCase } from "../../../presentation/useCases/delete/delete_motivo_demissao_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteMotivoDemissaoUseCase
 */

export class DeleteMotivoDemissaoUseCase implements IDeleteMotivoDemissaoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteMotivoDemissao(
    idMotivoDemissao: number,
  ): Promise<void> {
    await this.repository.deleteMotivoDemissao(
      idMotivoDemissao,
    );
  }
}